<div
    class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden mt-8 p-8">
    <form [formGroup]="doctorForm">
        <div class="form-group">
            <div class="form-control">
                <label>Titel</label>
                <input matInput placeholder="Dr. oder Dr. med..." formControlName="title">
            </div>
            <div class="form-control">
                <label>Vorname *</label>
                <input matInput placeholder="John" formControlName="firstName">
            </div>
            <div class="form-control">
                <label>Nachname *</label>
                <input matInput placeholder="Doe" formControlName="lastName">
            </div>
            <div class="form-control">
                <label>E-Mail *</label>
                <input matInput placeholder="mail@mail.com" formControlName="email">
            </div>
            <div class="form-control">
                <label>Telefonnummer</label>
                <input matInput placeholder="+49 123 456789" formControlName="telePhone">
            </div>
        </div>
        <div class="text-right">* Pfilchtfelder</div>
    </form>
    <div class="flex justify-between mt-4">
        <button class="btn secondary-button" (click)="cancel()">
            <span>Abbrechen</span>
        </button>
        <button class="btn primary-button" (click)="submit()">
            <span>Speichern</span>
        </button>
    </div>
</div>
